import React, { useState, FC, SetStateAction } from 'react'

interface context {
  setFilterData?:React.Dispatch<SetStateAction<FilterTypes>>,
  filterData:FilterTypes
}
interface FilterTypes {
	overview: boolean
	lmu: boolean
	se: boolean,
  dec: boolean,
  overviewHeader: string,
  lmuHeader: string,
  seHeader: string,
  eventId: Array<number>
  kioskId: Array<number>
}
const defaultState = {
	filterData: {
		overview: true,
		lmu: false,
		se: false,
		dec: false,
		overviewHeader: 'Overview',
		lmuHeader: 'LM United',
		seHeader: 'Jobs @ South East',
		eventId: [],
		kioskId: []
	}
}
export const StateContext = React.createContext<context>(defaultState)

export const StateProvider = ({ children }:any)=> {
	const [filterData, setFilterData] = useState(defaultState.filterData)

	return (
		<StateContext.Provider
			value={{
				filterData,
				setFilterData
			}}
		>
			{children}
		</StateContext.Provider>
	)
}

export default StateContext